import classNames from 'classnames'

import ErrorBoundary from 'containers/ErrorBoundary'
import style from './style.scss'

type Props = {
  children: React.ReactNode
  component?: { name: string; isFullWidth?: boolean }
  hasSidebar?: boolean
}
const FULL_WIDTH_COMPONENT_NAMES = [
  'ContentHeader',
  'FullWidthPromo',
  'FullWidthPromoWithCards',
  'NumericListPromo',
  'OnrampCTA',
  'OnrampMailingListCTA',
  'PageNotFound',
]

function ComponentWrapper({ component, children, hasSidebar }: Props) {
  const isFullWidth =
    component &&
    (FULL_WIDTH_COMPONENT_NAMES.includes(component.name) ||
      component.isFullWidth)

  const componentName = component && component.name.toLowerCase()
  return (
    <ErrorBoundary>
      <div
        className={classNames(
          style.wrapper,
          componentName && style[componentName],
          {
            [style.regular]: !isFullWidth,
            [style.hasSidebar]: hasSidebar,
            [style.fullWidth]: isFullWidth,
          },
        )}
      >
        {children}
      </div>
    </ErrorBoundary>
  )
}

export default ComponentWrapper
